import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';

import { gradient, rem } from '../../../core';

const modifiers = {
  primary: ({ theme }) => ({
    styles: `
      background-color: ${theme.primary.main};
      color: white;
    `,
  }),
  success: ({ theme }) => ({
    styles: `
      background-color: ${theme.greenLight3};
      color: ${theme.status.success};
    `,
  }),
  warning: ({ theme }) => ({
    styles: `
      background-color: ${theme.orangeLight1};
      color: ${theme.status.warning};
    `,
  }),
  danger: ({ theme }) => ({
    styles: `
      background-color: ${theme.redLight1};
      color: ${theme.status.danger};
    `,
  }),
  gradient: ({ theme }) => ({
    styles: `
      ${gradient(theme.gradient.dark, theme.gradient.light)};
      color: white;
    `,
  }),
};

export const TagStyled = styled.span.attrs({
  className: 'component__tag',
})`
  font-size: ${rem('12')};
  font-weight: bold;
  text-transform: uppercase;
  color: ${(props) => props.theme.content.main};
  background-color: ${(props) => props.theme.greyLight3};
  padding: ${rem('4')} ${rem('9')};
  display: inline-block;
  border-radius: ${rem('5')};
  ${applyStyleModifiers(modifiers)};
`;
